import _ from 'underscore';

export class BaseValidator {
  constructor(propertySchema) {
    this.propertySchema = propertySchema;
  }

  get requiredField() {
    throw new Error('requiredField Not implemented');
  }

  get config() {
    return {
      ignoreInvalidProperty: false,
    };
  }

  internalValidate() {
    throw new Error('internalValidate Not implemented');
  }

  enableCheck() {
    return !_.isUndefined(this.propertySchema[this.requiredField]);
  }

  validate(...args) {
    if (this.enableCheck()) {
      return this.internalValidate(...args);
    }

    return true;
  }
}
